<template>
	<div class="chief">
		<inline-svg class="glow-img" :src="glowImg"></inline-svg>
		<div class="left-chief">
			<div id="milan" class="chief-img-wrap">
				<img class="chief-img" src="@/assets/images/MILAN.png" alt="" />
			</div>
			<div class="left-space">
				<h3 class="desktop">Milan Škarić</h3>
				<h5 class="desktop">Chief Executive Officer</h5>
			</div>
			<div class="gradient-img"></div>
			<div class="left-holder">
				<div class="text">
					<h3 class="mobile">Milan Škarić</h3>
					<h5 class="mobile">Chief Executive Officer</h5>
					<p>
						<img src="@/assets/images/team/rec.svg" alt="" />
						<span>MSc. Computer Science</span>
					</p>
					<p>
						<img src="@/assets/images/team/rec.svg" alt="" />
						<span
							>25+ years of experience in software development, databases, and
							computer networks</span
						>
					</p>
					<p>
						<img src="@/assets/images/team/rec.svg" alt="" />
						<span>15+ years of teaching experience</span>
					</p>
					<p>
						<img src="@/assets/images/team/rec.svg" alt="" />
						<span>60+ projects across a wide range of industries</span>
					</p>
				</div>
			</div>
		</div>
		<div class="right-chief">
			<div id="sale" class="chief-img-wrap">
				<img class="chief-img" src="@/assets/images/sale.png" alt="" />
			</div>
			<div class="right-space">
				<h3 class="desktop">Aleksandar Ivanović</h3>
				<h5 class="desktop">Chief Technology Officer</h5>
			</div>
			<div class="gradient-img"></div>
			<div class="right-holder">
				<div class="text">
					<h3 class="mobile">Aleksandar Ivanović</h3>
					<h5 class="mobile">Chief Technology Officer</h5>
					<p>
						<img src="@/assets/images/team/rec.svg" alt="" />
						<span>MSc. Computer Science</span>
					</p>
					<p>
						<img src="@/assets/images/team/rec.svg" alt="" />
						<span
							>10+ years of experience in SAP consulting, analyzing, and
							improving enterprise business processes.</span
						>
					</p>
					<p>
						<img src="@/assets/images/team/rec.svg" alt="" />
						<span>
							8+ years of experience in software development using various
							technologies.</span
						>
					</p>
					<p>
						<img src="@/assets/images/team/rec.svg" alt="" />
						<span> 10+ years of experience in teaching lectures.</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import glowImg from "@/assets/images/upgraded/glow.svg";
</script>
<style scoped lang="scss">
$holder-color: rgb(19 24 31 / 1);
$holder-color-grad: rgb(19 24 31 / 0);

.chief {
	width: 100%;
	display: flex;
	gap: 1rem;
	flex-flow: row wrap;
	padding: 1rem 2rem;
	justify-content: center;

	@media screen and (width >= 768px) {
		padding: 0 4rem;
		justify-content: space-between;
	}

	.gradient-img {
		width: 100%;
		height: 16px;
		opacity: 0.7;
		background: radial-gradient(
			50% 50% at 50% 50%,
			#455a64 0%,
			rgb(69 90 100 / 0) 100%
		);
		z-index: 1;
	}

	.glow-img {
		position: absolute;
		margin: auto;
		max-width: 100%;
		top: -176px;
		transform: translateX(-50%);
		left: 50%;

		@media screen and (width < 768px) {
			top: -176px;
		}
	}

	.chief-img-wrap {
		position: absolute;
		background-color: transparent;
		width: 250px;
		height: 370px;
		display: grid;
		place-items: center;
		overflow: hidden;
		z-index: 1;

		.chief-img {
			position: absolute;
			bottom: 69px;
			height: 250px;
			transition-duration: 0.3s;
		}

		@media screen and (width < 768px) {
			align-self: center;
			left: unset !important;

			.chief-img {
				height: auto;
			}
		}
	}

	.left-chief {
		width: 100%;
		max-width: 600px;
		display: flex;
		flex-direction: column;

		.left-space {
			height: 300px;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;

			h3 {
				text-align: right;
				font-size: 26px;
				bottom: 0;
				right: 0;
				font-weight: 600;
			}

			h5 {
				color: $second-app-color;
				text-align: right;
				font-weight: 500;
				font-size: 20px;
			}
		}

		#milan {
			left: 0;
		}

		.left-holder {
			height: 300px;
			display: flex;
			flex-direction: column;

			// background: linear-gradient(
			// 	90deg,
			// 	$holder-color 0%,
			// 	$holder-color-grad 100%
			// );
			border-radius: 30px;

			.text {
				text-align: left;
				width: 100%;
				max-height: 100%;
				padding: 2rem 0 2rem 5rem;
				font-size: 18px;

				@media screen and (width < 768px) {
					font-size: 15px;
				}

				.mobile {
					display: none;
				}

				h3 {
					text-align: right;
					font-size: 26px;
					font-weight: 600;
				}

				h5 {
					color: $second-app-color;
					text-align: right;
					font-weight: 500;
					font-size: 20px;
					margin: 0 0 2rem;
				}

				p {
					text-align: left;
					margin-bottom: 0.5rem;
					display: flex;
					gap: 5px;

					img {
						height: 100%;
						margin-top: 10px;
					}
				}
			}

			@media screen and (width < 768px) {
				.text {
					h3,
					h5 {
						text-align: left;
					}
				}
			}
		}
	}

	.right-chief {
		width: 100%;
		max-width: 600px;
		display: flex;
		flex-direction: column;

		.right-space {
			height: 300px;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;

			h3 {
				text-align: left;
				font-size: 26px;
				bottom: 0;
				left: 0;
				font-weight: 600;
			}

			h5 {
				color: $second-app-color;
				text-align: left;
				font-weight: 500;
				font-size: 20px;
			}
		}

		#sale {
			right: 15px;
		}

		.right-holder {
			height: 300px;
			display: flex;
			flex-direction: column;

			// background: linear-gradient(
			// 	270deg,
			// 	$holder-color 0%,
			// 	$holder-color-grad 100%
			// );
			border-radius: 30px;

			.text {
				text-align: left;
				width: 100%;
				max-height: 100%;
				padding: 2rem 5rem 2rem 0;
				font-size: 18px;

				@media screen and (width < 768px) {
					font-size: 15px;
				}

				.mobile {
					display: none;
				}

				h3 {
					text-align: right;
					font-size: 26px;
					font-weight: 600;
				}

				h5 {
					color: $second-app-color;
					text-align: right;
					font-weight: 500;
					font-size: 20px;
					margin: 0 0 2rem;
				}

				p {
					margin-bottom: 0.5rem;
					text-align: left;
					display: flex;
					gap: 5px;

					img {
						height: 100%;
						margin-top: 10px;
					}
				}
			}

			@media screen and (width < 768px) {
				.text {
					h3,
					h5 {
						text-align: left;
					}
				}
			}

			.mobile {
				display: none;
			}
		}
	}
}

@media screen and (width <= 700px) {
	.chief {
		.left-chief {
			margin: 0;

			.left-space {
				.desktop {
					display: none;
				}

				.mobile {
					display: block;
				}

				h3 {
					z-index: 1;
					bottom: -6rem;
				}
			}

			.left-holder {
				height: 370px;

				h5 {
					margin-top: 6rem;
				}

				.text {
					text-align: right;
					padding: 1rem 0;

					.mobile {
						display: block;
					}
				}
			}
		}

		// SALE CSS
		.right-chief {
			margin: 0;

			.right-space {
				.desktop {
					display: none;
				}

				h3 {
					bottom: -6rem;
					z-index: 1;
				}
			}

			.right-holder {
				height: 370px;

				h5 {
					margin-top: 6rem;
				}

				.text {
					padding: 1rem 0;

					.mobile {
						display: block;
					}
				}
			}

			@media screen and (width < 768px) {
				.chief-img-wrap {
					right: unset !important;
				}
			}
		}
	}
}
</style>
